import { THEM_CHANGE } from "../constants/themeConstants";

export const changeTheme = (theme) => async (dispatch, getState) => {
  dispatch({
    type: THEM_CHANGE,
    payload: theme,
  });
  localStorage.setItem("theme", theme);
};
